import { Tag } from "@/types/prompt";
import { getTagWeightNum, getTagIncWeight, getTagDecWeight, lycoRegex, loraRegex, hasBrackets, weightNumRegex, setLayers, replaceTag } from "@/utils/common";

import { tagAdd, tagsAdd, tagRemove, tagUpdate, tagAddIndex, selectTagList } from "@/reducer/tagslice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

export const Tags = () => {
  const tagList = useAppSelector(selectTagList);
  const dispatch = useAppDispatch();
  const _setTagClass = (tag: Tag) => {
    tag.isLora = false;
    tag.loraExists = false;
    tag.isLyco = false;
    tag.lycoExists = false;
    tag.isEmbedding = false;

    if (typeof tag["type"] === "string" && tag.type === "wrap") {
    } else {
      // 判断是否lora
      const match = tag.value.match(loraRegex);
      if (match) {
        tag.isLora = true;
        // tag.loraName = match[1];
        // const loraName = this.loraExists(match[1]);
        if (match[1]) {
          tag.loraExists = true;
        }
      }

      if (!tag.isLora) {
        // 判断是否lyco
        const match = tag.value.match(lycoRegex);
        if (match) {
          tag.isLyco = true;
          // tag.lycoName = match[1];
          // const lycoName = this.lycoExists(match[1]);
          if (match[1]) {
            tag.lycoExists = true;
          }
        }
      }

      if (!tag.isLora && !tag.isLyco) {
        // 判断是否embedding
        // const embeddingName = this.embeddingExists(tag.value);
        // if (embeddingName !== false) {
        //   tag.isEmbedding = true;
        //   tag.value = embeddingName;
        //   tag.embeddingName = embeddingName;
        // } else {
        //   const embeddingName = this.embeddingExists(tag.originalValue);
        //   if (embeddingName !== false) {
        //     tag.isEmbedding = true;
        //     // tag.value = embeddingName
        //     tag.embeddingName = embeddingName;
        //   }
        // }
      }
    }
  };
  const handleTag = (tag: Tag) => {
    if (typeof tag["type"] === "string" && tag.type === "wrap") {
      tag.weightNum = 1;
      tag.incWeight = 0;
      tag.decWeight = 0;
    } else {
      tag.weightNum = getTagWeightNum(tag.value);
      // tag.weightNum = tag.weightNum <= 0 ? 1 : tag.weightNum
      // tag.weightNum = tag.weightNum === 0 ? 1 : tag.weightNum
      tag.incWeight = getTagIncWeight(tag.value, false);
      tag.decWeight = getTagDecWeight(tag.value);
      // const bracket = common.hasBrackets(tag.value)

      tag.originalValue = tag.value;
      if (!tag.value.match(loraRegex) && !tag.value.match(lycoRegex)) {
        // tag.weightNum = tag.weightNum <= 0 ? 1 : tag.weightNum
        let value = tag.value;
        const bracket = hasBrackets(value);
        if (Array.isArray(bracket)) {
          if ((bracket[0] === "(" && bracket[1] === ")") || (bracket[0] === "[" && bracket[1] === "]") || (bracket[0] === "{" && bracket[1] === "}" && false)) {
            // 移除括号
            value = setLayers(value, 0, bracket[0], bracket[1]);
            // 移除权重数
            tag.originalValue = value.replace(weightNumRegex, "$1");
          }
        }
      }
    }
    _setTagClass(tag);
  };

  const setTagValue = (value: string, localValue = "", disabled = false, index = -1, type = "text") => {
    const id = Date.now() + (Math.random() * 1000000).toFixed(0);
    let tag = {
      id,
      value,
      localValue,
      disabled,
      type,
      isLora: false,
      loraExists: false,
      isLyco: false,
      lycoExists: false,
      isEmbedding: false,
    } as Tag;
    handleTag(tag);
    return tag;
  };

  const addTag = (tagValue: string) => {
    const value = replaceTag(tagValue);
    const tag = setTagValue(value, value);
    dispatch(tagAdd(tag));
  };

  const addTags = (tags: string[]) => {
    const tagsTemp = [] as Tag[];
    for (let index = 0; index < tags.length; index++) {
      const tagValue = tags[index];
      const value = replaceTag(tagValue);
      const tag = setTagValue(value, value);
      tagsTemp.push(tag);
    }
    dispatch(tagsAdd(tagsTemp));
  };

  const removeTag = (index: number) => {
    dispatch(tagRemove(index));
  };

  const updateTag = (tag: Tag) => {
    dispatch(tagUpdate(tag));
  };

  const updateTagValue = (index: number,value: string, localValue = "") => {
    let tag = tagList[index];
    if (!tag) return;
    tag = { ...tag, value, localValue };
    handleTag(tag)
    dispatch(tagUpdate(tag));
  };

  const onIncWeightClick = (activeIndex: number, num: number) => {
    let tag = tagList[activeIndex];
    if (!tag) return;
    let value = tag.value;
    let localValue = tag.localValue;
    value = setLayers(value, 0, "[", "]");
    if (localValue !== "") localValue = setLayers(localValue, 0, "[", "]");
    // if (this.useNovelAiWeightSymbol) {
    //     value = setLayers(value, 0, '(', ')')
    //     if (localValue !== '') localValue = setLayers(localValue, 0, '(', ')')
    // }
    let incWeight = tag.incWeight;
    incWeight += num;
    if (incWeight < 0) incWeight = 0;
    // tag.incWeight = incWeight
    // tag.decWeight = 0

    // tag = Object.assign({},tag,{incWeight:incWeight})
    // tag = Object.assign({},tag,{decWeight:0})
    // if (this.useNovelAiWeightSymbol) {
    //     value = setLayers(value, incWeight, '{', '}')
    //     if (localValue !== '') localValue = setLayers(localValue, incWeight, '{', '}')
    // } else {

    // }
    value = setLayers(value, incWeight, "(", ")");
    if (localValue !== "") localValue = setLayers(localValue, incWeight, "(", ")");
    // tag.value = value
    if (localValue !== "") tag = { ...tag, localValue };

    tag = { ...tag, incWeight, decWeight: 0, value };
    dispatch(tagUpdate(tag));
  };
  const onDecWeightClick = (activeIndex: number, num: number) => {
    let tag = tagList[activeIndex];
    if (!tag) return;
    let value = tag.value;
    let localValue = tag.localValue;
    value = setLayers(value, 0, "(", ")");
    if (localValue !== "") localValue = setLayers(localValue, 0, "(", ")");
    // if (this.useNovelAiWeightSymbol) {
    //     value = setLayers(value, 0, '{', '}')
    //     if (localValue !== '') localValue = setLayers(localValue, 0, '{', '}')
    // }
    let decWeight = tag.decWeight;
    decWeight += num;
    if (decWeight < 0) decWeight = 0;
    // tag.incWeight = 0
    // tag.decWeight = decWeight
    value = setLayers(value, decWeight, "[", "]");
    if (localValue !== "") localValue = setLayers(localValue, decWeight, "[", "]");
    tag = { ...tag, incWeight: 0, decWeight, value };
    if (localValue !== "") tag = { ...tag, localValue };
    dispatch(tagUpdate(tag));
  };
  const onWrapTagClick = (activeIndex: number) => {
    let tag = tagList[activeIndex];
    if (!tag) return;
    let index = activeIndex;
    const wrapTag = setTagValue("\n", "\n", false, -1, "wrap");
    dispatch(tagAddIndex({ index, tag: wrapTag }));
  };

  const genPrompt = (tags: Tag[], ignoreDisabled = false) => {
    const autoRemoveSpace = true;
    const autoRemoveBeforeLineComma = false;
    const autoRemoveLoraBeforeComma = true;
    const autoRemoveLastComma = false;
    const autoRemoveLoraAfterComma = true;
    let prompts: string[] = [];
    let tags2: Tag[] = [];
    if (!ignoreDisabled) {
      for (let key in tags) {
        if (!tags[key].disabled) {
          tags2.push(tags[key]);
        }
      }
    } else {
      tags2 = tags;
    }
    let length = tags2.length;
    tags2.forEach((tag, index) => {
      let prompt = "";
      if (typeof tag["type"] === "string" && tag.type === "wrap") {
        prompt = "\n";
      } else {
        let value = replaceTag(tag.value);
        if (value !== tag.value) {
          tag = Object.assign({}, tag, { value: value });
          handleTag(tag);
        }
        let localValue = replaceTag(tag.localValue);
        if (localValue !== tag.localValue) {
          tag = Object.assign({}, tag, { localValue: localValue });
        }

        if (tag.weightNum > 0 || tag.weightNum < 0) {
          tag = Object.assign({}, tag, { weightNum: Number(tag.weightNum.toFixed(6)) });
          // tag.weightNum = Number(tag.weightNum.toFixed(6));
          // tag.value = tag.value.replace(weightNumRegex, "$1:" + tag.weightNum);
          tag = Object.assign({}, tag, { value: tag.value.replace(weightNumRegex, "$1:" + tag.weightNum) });
          if (tag.localValue !== "") {
            // tag.localValue = tag.localValue.replace(weightNumRegex, "$1:" + tag.weightNum);
            tag = Object.assign({}, tag, { value: tag.localValue.replace(weightNumRegex, "$1:" + tag.weightNum) });
          }
        }
        if (tag.disabled && !ignoreDisabled) return;

        let splitSymbol = "," + (autoRemoveSpace ? "" : " ");
        let splitSymbolDefault = splitSymbol;

        let nextTag = null;
        let nextIsWarp = false;
        let nextIsBreak = false;
        let nextIsLora = false;
        let nextIsLyco = false;
        // 获取下一个按钮
        if (index + 1 < length) {
          nextTag = tags2[index + 1];
          if (typeof nextTag["type"] === "string" && nextTag.type === "wrap") {
            nextIsWarp = true;
          } else if (nextTag.value === "BREAK") {
            nextIsBreak = true;
          } else if (nextTag.isLora) {
            nextIsLora = true;
          } else if (nextTag.isLyco) {
            nextIsLyco = true;
          }
        }

        if (nextIsWarp) {
          // 如果下一个是换行

          if (autoRemoveBeforeLineComma) {
            splitSymbol = "";
          } else {
            // sd-webui-regional-prompter
            const regionals = [" BREAK", " ADDCOL", " ADDROW", " ADDCOMM", " ADDBASE"];
            for (const regional of regionals) {
              if (tag.value.endsWith(regional)) {
                // 如果是sd-webui-regional-prompter，那么就不需要加逗号
                splitSymbol = "";
              }
            }
          }
        } else if (nextIsBreak) {
          splitSymbol = " ";
        } else if ((nextIsLora || nextIsLyco) && autoRemoveLoraBeforeComma) {
          splitSymbol = autoRemoveSpace ? "" : " ";
        }

        if (tag.value === "BREAK") {
          if (nextIsWarp) {
            splitSymbol = "";
          } else {
            splitSymbol = " ";
          }
        }

        if (autoRemoveLastComma && index + 1 === length) {
          // 如果是最后一个，那么就不需要加逗号
          splitSymbol = "";
        }

        if (splitSymbol === splitSymbolDefault && (tag.isLora || tag.isLyco) && autoRemoveLoraAfterComma) {
          splitSymbol = autoRemoveSpace ? "" : " ";
        }

        prompt = tag.value + splitSymbol;
      }
      if (prompt) prompts.push(prompt);
    });
    if (prompts.length <= 0) return "";
    // console.log('update tags', prompts)
    return prompts.join("");
  };

  const handleWeight = (activeIndex: number, e: number) => {
    let tag = tagList[activeIndex];
    if (!tag) return;
    if (tag.weightNum == e) return;
    let weightNum = e;
    let value = tag.value;
    let localValue = tag.localValue;
    let autoKeepWeightOne = false;
    let autoKeepWeightZero = false;
    if (weightNum != 0) {
      if (weightNum === 1 && !autoKeepWeightOne) {
        // 如果权重数是1，那么就去掉权重数
        const bracket = hasBrackets(value);
        if (Array.isArray(bracket)) {
          if ((bracket[0] === "(" && bracket[1] === ")") || (bracket[0] === "{" && bracket[1] === "}" && false)) {
            // 移除括号
            value = setLayers(value, 0, bracket[0], bracket[1]);
            if (localValue !== "") localValue = setLayers(localValue, 0, bracket[0], bracket[1]);
          } else {
            // 不移除括号
          }
          // 移除权重数
          value = value.replace(weightNumRegex, "$1");
          if (localValue !== "") localValue = localValue.replace(weightNumRegex, "$1");
        }
      } else {
        // 如果原来没有权重数，那么就加上权重数
        if (!weightNumRegex.test(value)) {
          // 如果原来有括号，就要加到括号内
          let bracket = hasBrackets(value);
          if (bracket && Array.isArray(bracket)) {
            value = setLayers(value, 1, bracket[0], bracket[1], ":" + weightNum);
            if (localValue !== "") localValue = setLayers(localValue, 1, bracket[0], bracket[1], ":" + weightNum);
          } else {
            value = value + ":" + weightNum;
            if (localValue !== "") localValue = localValue + ":" + weightNum;
          }
        } else {
          value = value.replace(weightNumRegex, "$1");
          if (localValue !== "") localValue = tag.localValue.replace(weightNumRegex, "$1");

          let bracket = hasBrackets(value);
          if (bracket && Array.isArray(bracket)) {
            value = setLayers(value, 1, bracket[0], bracket[1], ":" + weightNum);
            if (localValue !== "") localValue = setLayers(localValue, 1, bracket[0], bracket[1], ":" + weightNum);
          }
        }
        // 排除Lora、embedding、lyco
        // 如果原来没有括号() [] {}，那么就加上括号
        if (tag.isLora || tag.isLyco || tag.isEmbedding) {
        } else if (!hasBrackets(value)) {
          // if (this.useNovelAiWeightSymbol) {
          //     value = common.setLayers(value, 1, '{', '}')
          //     if (localValue !== '') localValue = common.setLayers(localValue, 1, '{', '}')
          // } else {
          //     value = common.setLayers(value, 1, '(', ')')
          //     if (localValue !== '') localValue = common.setLayers(localValue, 1, '(', ')')
          // }
          value = setLayers(value, 1, "(", ")");
          if (localValue !== "") localValue = setLayers(localValue, 1, "(", ")");
        }
      }
      if (value !== tag.value) {
        // tag.value = value
        tag = { ...tag, value };
        if (localValue !== "") tag = { ...tag, localValue };
        // this._setTag(tag)
        handleTag(tag);
      }
    } else {
      if (autoKeepWeightZero) {
        // 保留权重数
        // tag.value = value.replace(weightNumRegex, "$1:0");
        tag = { ...tag, value: value.replace(weightNumRegex, "$1:0") };
        if (localValue !== "") tag = { ...tag, localValue: tag.localValue.replace(weightNumRegex, "$1:0") }; //tag.localValue = tag.localValue.replace(weightNumRegex, "$1:0");
      } else {
        // 移除权重数
        // tag.value = value.replace(weightNumRegex, "$1");
        tag = { ...tag, value: value.replace(weightNumRegex, "$1") };
        if (localValue !== "") tag = { ...tag, localValue: tag.localValue.replace(weightNumRegex, "$1") }; //tag.localValue = tag.localValue.replace(weightNumRegex, "$1");
      }
    }
    // tag.weightNum = weightNum;
    tag = { ...tag, weightNum };
    dispatch(tagUpdate(tag));
  };

  return {
    addTag,
    addTags,
    removeTag,
    updateTag,
    updateTagValue,
    onIncWeightClick,
    onDecWeightClick,
    onWrapTagClick,
    genPrompt,
    handleWeight,
    tagList,
  };
};
